import { registerKeyboardShortcut } from '@databases/react';
import { useEffect } from 'react';

import { type SelectionsEffectMenuItem } from '../select-value-menu/types.ts';

/**
 * Registers keyboard shortcuts for context menu items that declare a keyboardShortcut.
 * Co-located with each item's elemAfter hint, so visual and functional bindings stay in sync.
 * Only mounted while the menu is visible — no additional visibility guard needed.
 */
export const useContextMenuKeyboardShortcuts = (
  resolvedItems: SelectionsEffectMenuItem[]
) => {
  useEffect(() => {
    const cleanups = resolvedItems.flatMap((item) => {
      if (!item.keyboardShortcut || !item.onClick) {
        return [];
      }

      const { keyboardShortcut, onClick } = item;

      return [
        registerKeyboardShortcut(keyboardShortcut, () => onClick({} as React.MouseEvent))
      ];
    });

    return () => {
      cleanups.forEach((cleanup) => cleanup());
    };
  }, [resolvedItems]);
};
